import { render, staticRenderFns } from "./RegisteredComplaintEmisor.vue?vue&type=template&id=2940ebca"
import script from "./RegisteredComplaintEmisor.vue?vue&type=script&lang=js"
export * from "./RegisteredComplaintEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports